import { render, staticRenderFns } from "./PartnersIntro.vue?vue&type=template&id=74cf1de4&scoped=true"
import script from "./PartnersIntro.vue?vue&type=script&lang=ts"
export * from "./PartnersIntro.vue?vue&type=script&lang=ts"
import style0 from "./PartnersIntro.vue?vue&type=style&index=0&id=74cf1de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cf1de4",
  null
  
)

export default component.exports